import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { lebanonPaConfig } from "./data";

export default function LebanonPaPage() {
  return <CityPageTemplate config={lebanonPaConfig} />;
}